export var EventBusEnum;
(function (EventBusEnum) {
    EventBusEnum["WEBSOCKET_MESSAGE"] = "WEBSOCKET_MESSAGE";
    EventBusEnum["WEBSOCKET_CONNECTED"] = "WEBSOCKET_CONNECTED";
    EventBusEnum["SHOW_COURSE_MODULES"] = "SHOW_COURSE_MODULES";
})(EventBusEnum || (EventBusEnum = {}));
